import { z } from 'zod';

import { ComponentValidator, ComponentPayloadValidator } from '../Component';

import { ComponentDefinition } from '../../types/ComponentDefinition';
import { AbstractPort, Port } from '../fields/AbstractPort';

const port = AbstractPort.extend({
    AC: Port.AC.default({}),
    DC: Port.DC.default({}),
}).default({
    powerFlowDirection: 'bidirectional',
});

const PanelBase = z.object({
    type: z.literal('panel').default('panel'),
    electrical: z
        .object({
            ports: z.array(port).min(1).default([undefined]),
        })
        .default({}),
});

export const PanelValidator = ComponentValidator.merge(PanelBase);
export const PanelPayloadValidator = ComponentPayloadValidator.merge(PanelBase);

export const PanelDefinition: ComponentDefinition = {
    type: 'panel',
    name: 'Panel Switchboard',
    description:
        'An assembly in which devices are mounted, such as circuit breakers, contactors, and meters for the purpose of protection and control. It is used to distribute electric power to circuits. It can have any number of AC and DC ports.',
    plural: 'Panels Switchboards',
    indicator: 'A',
    defaultColSpan: 2,
    hasDynamicNumberOfPorts: true,
    interoperabilityDataModel: false,
    ports: {
        min: 1,
        max: Infinity,
        powerFlowDirections: ['input', 'output', 'bidirectional'],
    },
    actsAsConverter: false,
    actsAsBus: true,
    liveData: {
        enabled: true,
        showGraphs: true,
    },
    validators: {
        component: PanelValidator,
        payload: PanelPayloadValidator,
    },
};

export type Panel = z.infer<typeof PanelValidator>;
export type PanelPayload = z.infer<typeof PanelPayloadValidator>;
